
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 24 24","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M19.02 20.95H4.98c-1.09 0-1.98-.89-1.98-1.98V5.03c0-1.09.89-1.98 1.98-1.98H15.2c.53 0 1.03.21 1.4.58l3.83 3.83c.36.37.57.87.57 1.4v10.11c0 1.09-.89 1.98-1.98 1.98zM4.98 4.34c-.38 0-.69.31-.69.69v13.94c0 .38.31.69.69.69h14.04c.38 0 .69-.31.69-.69V8.86c0-.18-.07-.36-.2-.49l-3.83-3.83a.68.68 0 0 0-.49-.2H4.98z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M16.36 13.65H7.64c-.82 0-1.48.66-1.48 1.48v4.52h1.29v-4.52c0-.11.09-.19.19-.19h8.73c.1 0 .19.09.19.19v4.52h1.29v-4.52c0-.82-.67-1.48-1.49-1.48zM7.75 10.15h2.07c.36 0 .65-.29.65-.65V4.34H6.15v4.21c0 .89.72 1.6 1.6 1.6z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M9.82 10.15h3.74c.88 0 1.6-.72 1.6-1.6V4.34h-1.29v4.21c0 .17-.14.31-.31.31h-3.09V4.34h-1.3V9.5c0 .36.29.65.65.65z"}})])
          )
        }
      }
    